import { createEntityQueries } from '@/shared/lib'

import { getItems, createItem } from '../api'

import { userNoteKeys } from './keys'

export const userNoteQueries = createEntityQueries({
  keys: userNoteKeys,
  getItems,
  create: createItem
})

export const { useList: useUserNotes, useCreate: useCreateUserNote } =
  userNoteQueries
